import React from "react";
import {Col, Row} from "antd";

const Mision : React.FC = () => {
    return (
        <section id={"about"} className={"main-about"}>
            <div className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>Misi</h2>
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <div className={"card-wrapper"}>
                            <p className={"subtitle"}>
                                1. Membantu pengembangan kualitas diri peserta didik melalui proses yang kreatif dan inovatif berdasar potensi dan kemampuan individu agar mencapai prestasi terbaik.
                                <br/><br/>
                                2. Membangun rasa kekeluargaan antar tim pengajar dengan para peserta didik agar tercipta proses belajar mengajar yang menyenangkan dan nyaman.
                                <br/><br/>
                                3. Mewujudkan cita - cita peserta didik untuk dapat mengenyam pendidikan di sekolah kedinasan.
                                <br/><br/>
                                4. Membangun profesionalisme manajemen lembaga serta infrastruktur yang berkualitas untuk pengembangan dalam dunia pendidikan.
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Mision);